import { getLink } from "@trydig/storyblok";
import { routing } from "@/i18n/routing";

export type LinkInsert = Parameters<typeof getLink>[0] | string;

export const sbLink = (link: Parameters<typeof getLink>[0] | string) => {
  const result = getLink(link as Parameters<typeof getLink>[0], [
    ...routing.groups,
    ...routing.languages,
  ]);

  // `getLink` drops the multilink's `anchor` field — it neither returns it nor
  // appends it to `href`. Re-attach it for internal links so in-page fragment
  // links (e.g. `some-page#pricing`) keep working. Skip external/mailto/tel
  // targets and hrefs that already carry a fragment.
  const anchor =
    result && typeof link === "object" && link
      ? (link as { anchor?: string }).anchor
      : undefined;

  if (result && anchor && !result.external && !result.href.includes("#")) {
    return { ...result, href: `${result.href}#${anchor}` };
  }

  return result;
};
